import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/daho6t3p14a1h3mr6pmg";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const formData = new FormData(formEl);

    const guard = ((formData.get("company_alt") as string) || "").trim();
    if (guard) {
      setStatus("success");
      setFormError("");
      formEl.reset();
      return;
    }
    formData.delete("company_alt");

    setStatus("loading");
    setFormError("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        formEl.reset();
      } else {
        setStatus("error");
        setFormError(
          serverMsg && typeof serverMsg === "string"
            ? serverMsg
            : "提交没有成功，请稍后再试一次。",
        );
      }
    } catch {
      setStatus("error");
      setFormError("网络连接出现问题，请检查网络后重试。");
    }
  };

  const inputClass =
    "w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400";

  return (
    <form id="daho6t3p14a1h3mr6pmg" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="contact-name" className="mb-2 block text-sm font-medium text-foreground-800">
            称呼
          </label>
          <input id="contact-name" type="text" name="name" required placeholder="怎么称呼你" className={inputClass} />
        </div>
        <div>
          <label htmlFor="contact-email" className="mb-2 block text-sm font-medium text-foreground-800">
            邮箱
          </label>
          <input
            id="contact-email"
            type="email"
            name="email"
            required
            placeholder="方便我们回复你"
            className={inputClass}
          />
        </div>
      </div>

      <div>
        <label htmlFor="contact-topic" className="mb-2 block text-sm font-medium text-foreground-800">
          来意
        </label>
        <select id="contact-topic" name="topic" required defaultValue="" className={inputClass}>
          <option value="" disabled>
            请选择你的来意
          </option>
          <option value="线索投稿">提供热点线索</option>
          <option value="内容合作">内容合作</option>
          <option value="转载授权">转载授权</option>
          <option value="纠错反馈">纠错与反馈</option>
          <option value="其他">其他事宜</option>
        </select>
      </div>

      <div>
        <label htmlFor="contact-message" className="mb-2 block text-sm font-medium text-foreground-800">
          详细说明
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请尽量附上可核验的公开链接，方便我们快速核实（最多 500 字）"
          className={`${inputClass} resize-none`}
        ></textarea>
      </div>

      <input
        type="text"
        name="company_alt"
        className="field-guard"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <div className="flex flex-wrap items-center gap-4">
        <button
          type="submit"
          disabled={status === "loading"}
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "loading" ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>提交中
            </>
          ) : (
            <>
              <i className="ri-send-plane-line"></i>提交信息
            </>
          )}
        </button>
        {status === "success" && (
          <p className="flex items-center gap-1 text-sm text-secondary-600">
            <i className="ri-checkbox-circle-line"></i>已收到，我们会尽快回复。
          </p>
        )}
        {status === "error" && (
          <p className="flex items-center gap-1 text-sm text-primary-600">
            <i className="ri-error-warning-line"></i>
            {formError}
          </p>
        )}
      </div>
    </form>
  );
}